import React, { useState, useEffect } from "react";
import "./LoginPage.css";
import { useNavigate } from "react-router-dom";
import socketClient from "../socket/socketClient";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { message } from "antd";
function LoginPage() {
  const [roomNumber, setRoomNumber] = useState("");
  const [name, setName] = useState("");
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate(); // Get the history object
  const handleInputChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setRoomNumber(e.target.value);
  };

  const handleInputNameChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setName(e.target.value);
  };

  const error = () => {
    message.error("socket连接报错");
  };

  const handleLoginClick = () => {
    // Handle login logic here
    console.log("Room Number: ", roomNumber);
    console.log("name: ", name);
    if (roomNumber && name) {
      localStorage.setItem("name", name);
      localStorage.setItem("room", roomNumber);
      setLoading(true);
      navigate(`/home?room=${roomNumber}&name=${name}`);
    } else {
      alert("请输入房间号和用户名");
    }
  };

  useEffect(() => {
    socketClient.addListener("login", {
      connectTimeOut,
      connectError,
    });
    // 返回一个清理函数
    return () => {
      socketClient.removeListener("login");
    };
  });

  function connectTimeOut() {
    setLoading(false);
    console.log("connectTimeOut");
  }

  function connectError() {
    error();
    setLoading(false);
    console.log("connectError");
  }
  return (
    <div className="login-container">
      <div>
        <span>房间号：</span>
        <input
          type="text"
          value={roomNumber}
          placeholder="请输入房间号"
          onChange={handleInputChange}
          className="login-input"
        />
      </div>

      <div>
        <span>用户名：</span>
        <input
          type="text"
          value={name}
          placeholder="请输入姓名"
          onChange={handleInputNameChange}
          className="login-input"
        />
      </div>

      <Button variant="primary" disabled={isLoading} onClick={handleLoginClick}>
        {isLoading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          "登录"
        )}
      </Button>
      <Button
        variant="primary"
        style={{ position: "fixed", left: "10px", bottom: "10px" }}
        onClick={() => {
          window.location.reload();
        }}
      >
        <FontAwesomeIcon icon={faSyncAlt} />
      </Button>
    </div>
  );
}

export default LoginPage;
